import { generateContext } from '@btime/react-contexts'
import React, { useCallback } from 'react'

import Clarity from '@microsoft/clarity'

const { ActionsContext, Provider } = generateContext()

export const useAnalytics = () => React.useContext(ActionsContext) || {}

export const AnalyticsProvider = ({ children, appId }) => {
  Clarity.init(appId)

  const identify = useCallback(customId => {
    Clarity.identify(customId, customId, customId, customId)
  }, [])

  const setTag = useCallback((key, value) => {
    Clarity.setTag(key, value)
  }, [])

  const setTags = useCallback(tags => {
    Object.entries(tags).forEach(([key, value]) => {
      Clarity.setTag(key, value)
    })
  }, [])

  const trackEvent = useCallback((eventName, properties = {}) => {
    Clarity.event(eventName, properties)
  }, [])

  const updateUserInfo = useCallback(userInfo => {
    Clarity.identify(Clarity.getUserId(), userInfo)
  }, [])

  const upgrade = useCallback(reason => {
    Clarity.upgrade(reason)
  }, [])

  const consent = useCallback(() => {
    Clarity.consent()
  }, [])

  const initAnalytics = useCallback(
    ({ user, workspace }) => {
      const customId = `${user.id}-${workspace}`
      identify(customId, customId, customId, customId)
      setTags({
        user_id: customId,
        user_name: user.name,
        user_email: user.email,
        workspace: workspace,
        app_version: process.env.REACT_APP_VERSION
      })
      consent()
    },
    [identify, consent]
  )

  return (
    <Provider actions={{ initAnalytics, identify, setTag, setTags, trackEvent, updateUserInfo, upgrade, consent }}>
      {children}
    </Provider>
  )
}

export default AnalyticsProvider
